import { Header } from '@setvi/shared/components/sdrawer-content/components/header';
import { DrawerContent } from '@setvi/shared/enums/common';
import { SSearchInput } from '@setvi/shared/components/sforms/ssearch';
import { AddressBook } from '@setvi/shared/components/sdrawer-content/components/contact/address-book';
import { TContact } from '@setvi/shared/components/sdrawer-content/components/contact';
import { Box } from '@material-ui/core';
import { ContactsLoader } from '@setvi/shared/components/sdrawer-content/components/contact/loader';
import { Subheader } from '../../components/subheader';
import { useContacts } from './useContacts';
import { SEmptyState } from '../../..';
import { ContactFilter } from '../../components/contact/contact-filter';
import { Recipient } from '../../../../interfaces';

interface ContactsProps {
  selectedContacts?: Recipient[];
  modifyRecipientList: (contact: TContact) => void;
  setShowContent: (content: DrawerContent | null) => void;
  handleClose: () => void;
}

export const Contacts = ({
  selectedContacts,
  modifyRecipientList,
  setShowContent,
  handleClose
}: ContactsProps) => {
  const {
    contacts,
    isLoading,
    setSearchString,
    fetchMoreContacts,
    sortBy,
    setSortBy
  } = useContacts();

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Header title="Recipients" handleClose={handleClose} />
      <Subheader
        handleBack={() => setShowContent(DrawerContent.contactsNavigation)}
        text="Contacts"
      />
      <Box p={2} mb={1} display="flex">
        <SSearchInput onChange={value => setSearchString(value)} />
        <ContactFilter sortBy={sortBy} setSortBy={setSortBy} />
      </Box>
      <Box overflow="auto">
        <AddressBook
          contacts={contacts}
          selectedContacts={selectedContacts}
          fetchMore={fetchMoreContacts}
          onContactClick={modifyRecipientList}>
          <>
            {isLoading && <ContactsLoader />}

            {!isLoading && contacts?.length === 0 && (
              <SEmptyState
                imageSrc="/images/no-contacts-2.png"
                subTitle="No contacts available"
              />
            )}
          </>
        </AddressBook>
      </Box>
    </Box>
  );
};
